import { Component, computed, DestroyRef, inject, Input, OnInit, signal, input } from '@angular/core';


@Component({
    selector: 'lib-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  #destroyRef = inject(DestroyRef);
  @Input() fullScreen: boolean = false;
  @Input() containerCustomStyle?: string;
  @Input() customStyle?: string;
  @Input() disableScrolling?: boolean;

  spinnerStyle = input<'default' | 'singleRing'>('default');

  loadingMessages = input<Array<string>>([]);
  messageCycleMS = input<number>(3000);

  currentMessageIndex = signal<number>(0);
  currentMessage = computed(() => this.loadingMessages()[this.currentMessageIndex()]);

  ngOnInit(): void {
    if (this.loadingMessages().length <= 1) {
      return;
    }

    const intervalId = setInterval(() => {
      this.currentMessageIndex.update(index => (index + 1) % this.loadingMessages().length);
    }, this.messageCycleMS());

    this.#destroyRef.onDestroy(() => clearInterval(intervalId));
  }
}
